/* ALL DAY FIRE - offer card v2 behaviour (sections/adf-offer-v2.liquid) */
(function () {
  /* Offer card v2: option cards <-> selling_plan input <-> bonus lock <-> button label <-> sticky price. */
  function adfOfferV2Init(root) {
    var dataEl = root.querySelector('[data-adf-ov2-json]');
    var data = { plans: {} };
    try { data = JSON.parse(dataEl.textContent); } catch (e) {}
    var planInput = root.querySelector('[data-adf-plan-input]');
    var atc = root.querySelector('[data-adf-atc]');
    var atcText = root.querySelector('[data-adf-atc-text]');
    var frequency = root.querySelector('[data-adf-frequency]');
    var options = root.querySelectorAll('[data-adf-option]');
    var bonuses = root.querySelector('[data-adf-bonuses]');
    var sticky = document.querySelector('adf-offer-v2-sticky[data-target="#' + root.id + '"]');
    var stickyPrice = sticky ? sticky.querySelector('[data-adf-sticky-price]') : null;
    var stickyCompare = sticky ? sticky.querySelector('[data-adf-sticky-compare]') : null;
    var stickyText = sticky ? sticky.querySelector('[data-adf-sticky-text]') : null;
    var stickyCustom = sticky ? sticky.getAttribute('data-custom-label') === 'true' : false;

    function subOpt() { return root.querySelector('[data-adf-option="subscription"]'); }
    function currentPlanId() {
      var so = subOpt();
      if (!so || !so.classList.contains('is-selected')) return '';
      return frequency ? frequency.value : ((so.querySelector('input') || {}).value || '');
    }
    function setText(sel, val) {
      var el = root.querySelector(sel);
      if (el) el.textContent = val || '';
    }
    function render() {
      var planId = currentPlanId();
      var so = subOpt();
      var planKey = frequency ? frequency.value : (so ? ((so.querySelector('input') || {}).value || '') : '');
      var alloc = data.plans && data.plans[planKey];
      if (so && alloc) {
        setText('[data-adf-sub-price]', alloc.price);
        setText('[data-adf-sub-compare]', alloc.compare_at);
        setText('[data-adf-sub-day]', alloc.per_day);
        var label = root.querySelector('[data-adf-sub-label]');
        if (label) label.textContent = (label.dataset.template || '').replace('[discount]', alloc.pct);
        root.querySelectorAll('[data-adf-bullet]').forEach(function (b) {
          b.textContent = (b.dataset.template || '').replace('[discount]', alloc.pct);
        });
      }
      if (planInput) planInput.value = planId;
      if (bonuses) bonuses.classList.toggle('is-locked', !planId);
      root.querySelectorAll('[data-adf-terms]').forEach(function (t) {
        t.hidden = (t.dataset.adfTerms === 'subscription') !== !!planId;
      });
      var btnLabel = planId && atc && atc.dataset.labelSub ? atc.dataset.labelSub : ((atc && atc.dataset.label) || 'Add to cart');
      var available = !!data.available;
      if (atc) {
        atc.disabled = !available;
        if (atcText) atcText.textContent = available ? btnLabel : data.sold_out;
      }
      if (stickyPrice) stickyPrice.textContent = planId && alloc ? alloc.price : data.price;
      if (stickyCompare) stickyCompare.hidden = !(planId && alloc);
      if (stickyText && !stickyCustom) stickyText.textContent = available ? btnLabel : data.sold_out;
    }
    function selectOption(key) {
      options.forEach(function (opt) {
        var on = opt.dataset.adfOption === key;
        opt.classList.toggle('is-selected', on);
        var input = opt.querySelector('input');
        if (input) input.checked = on;
      });
    }
    var lastTracked = null;
    function trackOption(key, via) {
      if (key === lastTracked) return;
      lastTracked = key;
      try {
        document.dispatchEvent(new CustomEvent('adf:offer:change', { detail: { option: key, via: via, section: root.id } }));
        if (window.dataLayer && typeof window.dataLayer.push === 'function') {
          window.dataLayer.push({ event: 'adf_purchase_option', adf_option: key, adf_via: via });
        }
      } catch (e) {}
    }
    var sel = root.querySelector('[data-adf-option].is-selected');
    if (sel) lastTracked = sel.dataset.adfOption;

    options.forEach(function (opt) {
      var input = opt.querySelector('input');
      if (!input) return;
      input.addEventListener('change', function () { selectOption(opt.dataset.adfOption); render(); trackOption(opt.dataset.adfOption, 'card'); });
      opt.addEventListener('click', function (e) {
        if (e.target.closest('select')) return;
        selectOption(opt.dataset.adfOption); render(); trackOption(opt.dataset.adfOption, 'card');
      });
    });
    if (frequency) frequency.addEventListener('change', function () { selectOption('subscription'); render(); });
    var unlockBtn = root.querySelector('[data-adf-unlock]');
    if (unlockBtn) unlockBtn.addEventListener('click', function () {
      selectOption('subscription'); render(); trackOption('subscription', 'unlock');
      var so = subOpt();
      if (so && so.getBoundingClientRect().top < 0 && so.scrollIntoView) {
        so.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });

    /* Gallery: the small images swap the main image (snippets/adf-ov2-thumb.liquid). */
    var mainImg = root.querySelector('.adf-ov2__main img');
    var thumbs = root.querySelectorAll('[data-adf-thumb]');
    if (mainImg && thumbs.length) {
      thumbs.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var src = btn.dataset.src;
          if (!src) return;
          mainImg.srcset = btn.dataset.srcset || '';
          mainImg.src = src;
          mainImg.alt = btn.dataset.alt || '';
          thumbs.forEach(function (b) {
            var on = b === btn;
            b.setAttribute('aria-pressed', on ? 'true' : 'false');
            var li = b.closest('.adf-ov2__thumb');
            if (li) li.classList.toggle('is-active', on);
          });
        });
      });
    }
    render();
  }

  if (!customElements.get('adf-offer-v2')) {
    customElements.define('adf-offer-v2', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.adfReady) return;
        this.dataset.adfReady = '1';
        try { adfOfferV2Init(this); } catch (e) {}
      }
    });
  }

  /* Mobile sticky bar: show once the first section has scrolled away, hide while the offer card is on screen.
     The button submits the card's own form (same variant + selling plan), so the cart drawer opens as usual. */
  if (!customElements.get('adf-offer-v2-sticky')) {
    customElements.define('adf-offer-v2-sticky', class extends HTMLElement {
      connectedCallback() {
        try {
          var self = this;
          var btn = self.querySelector('[data-adf-sticky-btn]');
          var form = document.getElementById(self.dataset.form || '');
          if (btn) btn.addEventListener('click', function () {
            if (!form) return;
            if (form.requestSubmit) form.requestSubmit(); else form.submit();
          });
          if (!('IntersectionObserver' in window)) return;
          self.pastTop = false;
          self.offerVisible = true;
          var target = document.querySelector(self.dataset.target || '#adf-offer');
          var main = document.getElementById('MainContent');
          var first = main ? main.querySelector('.shopify-section') : null;
          if (first === (target && target.closest('.shopify-section'))) first = null;
          self._io = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (entry.target === target) self.offerVisible = entry.isIntersecting;
              if (entry.target === first) self.pastTop = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
            });
            self.update();
          }, { threshold: 0 });
          if (target) self._io.observe(target); else self.offerVisible = false;
          if (first) self._io.observe(first); else self.pastTop = true;
          self.update();
        } catch (e) {}
      }
      disconnectedCallback() { if (this._io) this._io.disconnect(); }
      update() {
        var show = this.pastTop && !this.offerVisible;
        this.setAttribute('data-visible', show ? 'true' : 'false');
        this.setAttribute('aria-hidden', show ? 'false' : 'true');
      }
    });
  }
})();